export async function publishToPubSub(
  event: string,
  authToken: string,
  hierarchicalMetadata: any,
  studyCondition : string | null = null,
  error: string = '',
  file: string = 'dicom',
  humanSubjectId: string | null = null
) {
  try {
    const { pubsub, viewer } = (window as any).data;
    let studyInstanceUID = '',
      studyDate = '';
    if (hierarchicalMetadata) {
      studyInstanceUID = hierarchicalMetadata?.studies[0].StudyInstanceUID;
      studyDate = hierarchicalMetadata?.studies[0].StudyDate;
    }
    const userEmail = localStorage.getItem('userEmail');
    const viewerURL = viewer?.viewerBaseURL 
      ? `${viewer.viewerBaseURL}?StudyInstanceUIDs=${studyInstanceUID}`
      : null;

    const message = {
      actionType: event,
      studyInstanceUID: studyInstanceUID,
      Stratagen_Study_Type: studyCondition,
      studyDate: studyDate,
      error: error,
      contentType: file,
      uploadedBy: userEmail,
      ...(humanSubjectId && { humanSubjectId: humanSubjectId }),
      ...(viewerURL && { viewerURL: viewerURL })
    };

    const response = await fetch(pubsub.cloudFunctionURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message: message }),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
  } catch (error) {
    console.error(`Failed to publish message ${error}`);
  }
}
